import { Button } from '@seen/ui'
import { IconCheck, IconCopy } from '@tabler/icons-react'
import type { JSX } from 'react'
import { useCopyToClipboard } from '#src/hooks/useCopyToClipboard.ts'

interface CopyButtonProps {
  // Text to copy; the button is a no-op when undefined or empty.
  value: string | undefined
  ariaLabel?: string
  className?: string
}

// Ghost icon button that copies `value` and confirms with the shared
// copied-to-clipboard toast, briefly swapping to a check icon.
export function CopyButton({
  value,
  ariaLabel = 'Copy',
  className,
}: CopyButtonProps): JSX.Element {
  const { copied, copy } = useCopyToClipboard()
  return (
    <Button
      variant="ghost"
      size="icon"
      className={className}
      aria-label={ariaLabel}
      onClick={() => {
        if (value) {
          void copy(value)
        }
      }}
    >
      {copied ? (
        <IconCheck className="size-4" />
      ) : (
        <IconCopy className="size-4" />
      )}
    </Button>
  )
}
